import { useTranslation } from 'react-i18next';
import { Camera, Sparkles, Star } from 'lucide-react';

export const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: Camera,
      title: t('howItWorks.step1Title', 'Take a Photo'),
      description: t('howItWorks.step1Desc', 'Use your camera or choose from gallery'),
    },
    {
      icon: Sparkles,
      title: t('howItWorks.step2Title', 'AI Analyzes'),
      description: t('howItWorks.step2Desc', 'Our AI evaluates decoration, lighting, and trends'),
    },
    {
      icon: Star,
      title: t('howItWorks.step3Title', 'Get Your Score'),
      description: t('howItWorks.step3Desc', 'Receive rating and personalized tips'),
    },
  ];

  return (
    <section className="w-full max-w-4xl mx-auto py-12 px-4">
      <h2 className="text-3xl font-bold text-center text-foreground mb-2">
        {t('howItWorks.title', 'How It Works')}
      </h2>
      <p className="text-center text-muted-foreground mb-8">
        {t('howItWorks.subtitle', 'Rate your Christmas tree in 3 simple steps')}
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((step, index) => (
          <div key={index} className="flex flex-col items-center text-center space-y-4">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
              <step.icon className="w-8 h-8 text-primary" />
            </div>
            <div className="space-y-2">
              <h3 className="text-xl font-semibold text-foreground">{step.title}</h3>
              <p className="text-sm text-muted-foreground">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
